// 所有路由的名称枚举
export enum RouterH5Enum {
  home = '/home',
  login = '/login',
  loginSms = '/login/sms',
  loginCaptcha = '/login/captcha',
  redirectApp = '/h5/redirect-app',
  redirectAppForDeposit = '/h5/redirect-app-deposit',
}

export enum RouterV2Enum {
  aliminiHome = '/alimini-home', // 支付宝首页
  taglessAliminiHome = '/alimini-home/alimini-tagless-home', // 支付宝新用户
  qualityAliminiHome = '/alimini-home/alimini-quality-home', // 支付宝品质版
  aliApplyFaildHome='/alimini-home/alimini-failed-home', // 支付宝授信失败首页
  aliCreditBlocked='/ali-credit-blocked', // 支付宝授信受阻页（放款暂停）
  qualityHomePage = '/v2/home/app-quality-home', // 品质首页
  qualityHomeWithAdvert = '/v2/home/app-quality-home/advert',
  home = '/v2/home', // 首页主入口
  taglessHome = '/v2/home/app-tagless-home', // 无标签首页
  myProfile = '/v2/my-profile',
  baseInfo = '/v2/base-info', // 资料页面，现已全量下线，请使用verifyCredit页面代替
  verifyCredit = '/v2/verify-credit',
  /** 授信现金活动无法参与结果页 */
  cashActivityDisqualification = '/v2/cash-activity-disqualification',
  /** 授信现金活动参与成功结果页 */
  cashActivitySuccess = '/v2/cash-activity-success',
  preApplyChoose = '/v2/pre-apply-choose',
  dcPreApplyChoose = '/v2/dc-pre-apply-choose',
  applyProduct = '/v2/apply-product',
  applyResult = '/v2/apply-result',
  myPreApply = '/v2/my-pre-apply',
  myApply = '/v2/my-apply',
  repay = '/v2/repay',
  repayRecords = '/v2/repay-records',
  preApplyResult = '/v2/pre-apply-result',
  cardList = '/v2/card-list',
  /** 绑卡页 */
  cardBind = '/v2/card-bind',
  /** 银行卡账户类型介绍页 */
  accountTypeInfo = '/v2/account-type-info',
  /** 数币钱包页 */
  walletBind = '/v2/wallet-bind',
   /** 数币钱包教程页 */
  walletTutorial = '/v2/wallet-tutorial',
  preApplyFailed = '/v2/pre-apply-failed',
  alipay = '/v2/alipay',
  aboutUs = '/v2/about-us',
  aboutUsList = '/v2/about-us-list',
  contractList = '/v2/contract-list',
  helpCenter = '/v2/help-center',
  campaignShare = '/v2/campaign-share',
  feedBack = '/v2/feedback',
  myCoupon = '/v2/my-coupon',
  toolBox = '/v2/tool-box',
  toolBoxResult = '/v2/tool-box-result',
  selectedCoupon = '/v2/select-coupon',
  setting = '/v2/setting',
  security = '/v2/security',
  newRedirect = '/v2/new-redirect',
  applyDetails = '/v2/apply-details',
  legalConstract = '/v2/legal-contract',
  cooperationChannel = '/v2/cooperation-channel',
  channelConstract = '/v2/channel-constract',
  myBillAll = '/v2/my-bill-all',
  myBill = '/v2/my-bill',
  usingGuid = '/v2/using-guid',
  marketPage = '/v2/market-page',
  /** 补充资料（后续可以整个路由及文件夹移除） */
  additionalInfo = '/v2/additional-info',
  /** 补充资料（应用coffee表单组件） */
  supplementInfo= '/v2/supplement-info',
  /** 引导下载hello App页面（小程序、钉钉） */
  guideDownload = '/v2/guide-download',
  /** 支付宝授信成功引导下载页面 */
  alipayCreditGuide = '/v2/alipay-credit-guide',
  smsDownload = '/v2/sms-download',
  transfer = '/v2/transfer',
  /** 防诈指南 */
  antiFraudCenter = '/v2/antiFraudCenter',
  /** 唤起app营销落地页 */
  evokeAppMarket = '/v2/evoke-app-market',
  /** 提现等待页面 */
  withdrawalWaiting = '/v2/withdrawal-waiting',
  /** 分期商城等待页面（轮询授信结果） */
  unitWaitingPage = '/v2/unit-waiting-page',
  /** 分期商城授信成功结果页 */
  fqMallPreApplySuccess = '/v2/fq-mall-pre-apply-success',
  /** 分期商城授信协议页 - 确定分发到分期商城 */
  fqMallPreApply = '/v2/fq-mall-pre-apply',
  /** 中收授信协议页 */
  middleIncomeContract = '/v2/middle-income-contract',
}

export enum RouterV3Enum {
  home = '/v3/home', // 新版v3首页
  activityHome = '/v3/activity-home', // 活动版首页
}

// 配置当前登录场景白名单
export const WHITE_LIST = {
  [RouterH5Enum.login]: false,
  [RouterV2Enum.newRedirect]: false,
  [RouterV2Enum.marketPage]: false,
  [RouterV2Enum.smsDownload]: false,
  [RouterV2Enum.evokeAppMarket]: false,
  [RouterV2Enum.usingGuid]: false,
};
